"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../components/StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const GrayBackgroundGridRow = (0, _styledComponents.default)((0, _BaseComponents.GrayBackground)('div'))`
  overflow: auto;
`;
const Container = _styledComponents.default.div`
  min-height: 100vh;
  height: 100%;
  padding: 30px 20px;
  ${_r10SourceLibrary.Mixins.respondTo.lg(`
  padding: 50px 150px;

 `)}
  ${_r10SourceLibrary.Mixins.respondTo.xl(`
  padding: 50px 350px;

 `)}
`;
const FullPage = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(GrayBackgroundGridRow, null, /*#__PURE__*/_react.default.createElement(Container, null, children));
};
var _default = FullPage;
exports.default = _default;